import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/common.model';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private baseUrl = environment.baseUrlAdmin;

  constructor(private http: HttpClient) { }

  public getProductSummary(productId, isBiz = false): Observable<any> {
    return this.http.post(`${this.baseUrl}getProductSummary`, { productId, isBiz })
  }

  public getMemberShopProductList(payload: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      `${this.baseUrl}community/product-list-for-marketplace`,
      payload
    );
  }

  public getTopCategoryProducts(payload): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(
      `${this.baseUrl}community/top-category-products`,
      payload
    );
  }

  public getTgBotRegistration() {
    return this.http.get(`${this.baseUrl}getTgBotRegistration`);
  }
  public registerTgBot(tgToken) {
    return this.http.post(`${this.baseUrl}registerTgBot`, {
      tgToken,
    });
  }

  public getProfileInfo(user = null, isReferral = false, forceID = false): Observable<any> {
    if (user) {
      return this.http.get(`${this.baseUrl}getProfileInfo${forceID ? '?forceID=1' : ''}`, {
        params: {
          [`${isReferral ? 'referralCode' : 'user'}`]: user,
        },
      });
    } else {
      return this.http.get(`${this.baseUrl}getProfileInfo`);
    }
  }

  public getAvailableTasks(params: any): Observable<ApiResponse> {

    return this.http.get<ApiResponse>(`${this.baseUrl}community/get-available-tasks`, {
      params: params
    });
  }

  public applyTask(taskId: number): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.baseUrl}community/apply-task`, { taskId });
  }

  public submitTask(formData: FormData): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`${this.baseUrl}community/submit-task`, formData);
  }

  public getProfileMatrix(userId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}getProfileMatrix?userId=${userId}`);
  }

  public getBizProfiles(): Observable<any> {
    return this.http.get(`${this.baseUrl}getBizProfiles`);
  }

  //  *** Notification ***
  public getAllNotificationsForMember(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllNotificationsForMember`);
  }

  public popularMemberShopKeyword(isAdmin = 0): Observable<any> {
    return this.http.get(
      `${this.baseUrl}membershop-keywords-popular?isAdmin=${isAdmin}`
    );
  }

  public popularMemberShopKeywordChangeStatus(payload: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}membershop-keywords-popular-change`,
      payload
    );
  }

  public getCharacterListForMember(): Observable<any> {
    return this.http.get(`${this.baseUrl}getCharacterListForMember`);
  }

  public getShopStatus(): Observable<any> {
    return this.http.get(`${this.baseUrl}getShopStatus`);
  }

  public getMemberShopsProfile(): Observable<any> {
    return this.http.get(`${this.baseUrl}getMemberShopsProfile`);
  }

  public getAllShopProduct(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getAllShopProduct`, payload);
  }

  public getFavoriteProducts(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getFavoriteProducts`, payload);
  }

  public getMemberShopsProfileById(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getMemberShopsProfileById`, payload);
  }

  public getRolesForMember(): Observable<any> {
    return this.http.get(`${this.baseUrl}getRolesForMember`);
  }

  public removeCard(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}removeCard`, payload);
  }

  public saveMemberEmail(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}saveMemberEmail`, payload);
  }
  public verifyEmailOtp(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}verifyEmailOtp`, payload);
  }

  public getOnlineMember(): Observable<any> {
    return this.http.get(`${this.baseUrl}getOnlineMember`);
  }

  public setProfileToDefault(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}setProfileToDefault`, payload);
  }

  public getSupported(): Observable<any> {
    return this.http.get(`${this.baseUrl}getSupported`);
  }

  public hideMemberShopAsk(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}hideMemberShopAsk`, payload);
  }

  public updateUserMuteStatus(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateUserMuteStatus`, payload);
  }

  public updateUserBlockStatus(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateUserBlockStatus`, payload);
  }

  public deleteUser(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}deleteUser`, payload);
  }

  public getReferralUsers(
    page: number = 1,
    limit: number = 10
  ): Observable<any> {
    return this.http.get(
      `${this.baseUrl}getReferralUsers?page=${page}&limit=${limit}`
    );
  }

  public changeClaimStatus(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}changeClaimStatus`, payload);
  }

  public getSurveyResponses(): Observable<any> {
    return this.http.get(`${this.baseUrl}getSurveyResponses`);
  }

  public updateTag(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}updateTag`, payload);
  }

  // JobPost
  public addMemberJobPost(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addMemberJobPost`, payload);
  }

  public deleteMemberJobPost(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberJobPost/${id}`);
  }

  public getMemberJobPost(): Observable<any> {
    return this.http.get(`${this.baseUrl}getMemberJobPost`);
  }

  public getAllJobPost(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllMemberJobPost`);
  }

  // JobPost

  public login(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}login-member`, payload);
  }

  public galleryLikes(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}galleryLikes`, payload);
  }

  public userGallery(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}userGallery`, {
      params: payload,
    });
  }
  public userExperiences(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}userExperiences`, {
      params: payload,
    });
  }

  public getBizByRegion(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}getBizByRegion`, payload);
  }

  public getBizProductList(filter: any): Observable<any> {
    return this.http.get(this.baseUrl + `marketplace_food_listing`, {
      params: filter,
    });
  }

  public getBizCategories(): Observable<any> {
    return this.http.get(this.baseUrl + `marketplace_categories`);
  }

  public getBizBrandList(): Observable<any> {
    return this.http.get(`${this.baseUrl}brands`);
  }

  public getAllCommunityProductCategoryList(): Observable<any> {
    return this.http.get(`${this.baseUrl}getAllCategoriesList`);
  }

  public getBizShopBanner(adminId) {
    return this.http.get(this.baseUrl + `get_all_product_banner/${adminId}`);
  };

  public jobPostView(id: any): Observable<any> {
    return this.http.get(`${this.baseUrl}jobPostView?id=` + id);
  }

  public addMemberSupport(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}addmemberSupport`, payload);
  }

  public deleteMemberSupport(id: number) {
    return this.http.delete(`${this.baseUrl}deleteMemberSupport/${id}`);
  }

  public getUserSupportList(): Observable<any> {
    return this.http.get(`${this.baseUrl}getUserSupportList`);
  }

  public deleteReportProduct(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}deleteReportProduct`, payload);
  }

  public getSchema(type: string) {
    return this.http.get(`${this.baseUrl}meta/schema/get`, {
      params: {
        type: type
      }
    });
  }

  public getProductReviews(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/product-reviews-by-region`, payload);
  }

  public checkoutCreate(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}checkout/create`, payload);
  }

  public checkoutManage(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}checkout/manage`, payload);
  }

  public checkoutHistory(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}checkout/history`, {
      params: payload
    });
  }

  public checkSurvey(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}survey/check-survey`, payload);
  }

  public pinTask(taskId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}community/pin-task`, { taskId });
  }

  public getPinnedTasks(): Observable<any> {
    return this.http.get(`${this.baseUrl}community/get-pinned-tasks`);
  }

  public getYoutubeUrl(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/get-youtube-url`, {
      params: payload
    });
  }
  public deleteTask(taskId: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}community/delete-task/${taskId}`);
  }

  public pauseTask(taskId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}community/pause-task`, { taskId });
  }

  public markAsUnreport(productId: number): Observable<any> {
    return this.http.post(`${this.baseUrl}mark-as-unreport`, { productId })
  }

  public getComicChats(params: any): Observable<any> {
    // Add cache busting parameter
    const cacheBustingParams = {
      ...params,
      _t: Date.now() // Add timestamp to prevent caching
    };

    return this.http.get(`${this.baseUrl}community/get-comic-chats`, {
      params: cacheBustingParams,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
  }

  public addComicChat(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/add-comic-chat`, payload);
  }

  public deleteComicChat(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}community/delete-comic-chat/${id}`);
  }

  public getDiscount(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}discount/get`, {
      params: payload
    });
  }

  public createDiscount(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}discount/create`, payload);
  }

  public uploadDiscount(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}discount/upload`, payload);
  }

  public deleteDiscount(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}discount/delete`, payload);
  }

  public deleteUploadedImage(id: number, imageIndex?: number): Observable<any> {
    let url = `${this.baseUrl}discount/delete-uploaded-image/${id}`;
    if (imageIndex !== undefined && imageIndex !== null) {
      url += `?imageIndex=${imageIndex}`;
    }
    return this.http.delete(url);
  }

  public getMemberShopCategoriesFAQ(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/get-member-shop-categories-faq`, {
      params: payload
    });
  }

  public addMemberShopCategoriesFAQ(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/add-member-shop-categories-faq`, payload);
  }

  public getTagList(productId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}getTagList/${productId}`);
  }

  public getMapLinks(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/get-map-links`, {
      params: payload
    });
  }

  public addMapLink(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/add-map-link`, payload);
  }

  public deleteMapLink(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}community/delete-map-link/${id}`);
  }

  public getMapCalculator(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/get-map-calculator`, {
      params: payload
    });
  }

  public addMapCalculator(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/add-map-calculator`, payload);
  }
  public deleteMapCalculator(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}community/delete-map-calculator/${id}`);
  }

  public getMapSingleText(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/get-map-single-text`, {
      params: payload
    });
  }

  public addMapSingleText(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/add-map-single-text`, payload);
  }

  public countForumMap(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}forum/count-forum-map`, payload);
  }

  public getMapOthers(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}mapOthers/get`, {
      params: payload
    });
  }

  public createMapOthers(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}mapOthers/create`, payload);
  }

  public deleteMapOthers(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl}mapOthers/delete`, { id });
  }

  public createContent(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}discount/create-content`, payload);
  }

  public deleteContent(id: number): Observable<any> {
    return this.http.post(`${this.baseUrl}discount/delete-content`, { id });
  }

  public getMapTags(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/get-map-tags`, {
      params: payload
    });
  }

  public addMapTag(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/add-map-tag`, payload);
  }

  public getMapTagsRank(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/get-map-tags-rank`, {
      params: payload
    });
  }

  public getMapShareWithOthers(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/map-share-with-others/get`, {
      params: payload
    });
  }

  public addMapShareWithOthers(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/map-share-with-others/add`, payload);
  }

  public editMapShareWithOthers(id: number, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}community/map-share-with-others/edit/${id}`, payload);
  }

  public deleteMapShareWithOthers(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}community/map-share-with-others/delete/${id}`);
  }

  public getMapShareWithOthersReplies(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/map-share-with-others/get-replies`, {
      params: payload
    });
  }

  public addMapShareWithOthersReply(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/map-share-with-others/add-reply`, payload);
  }

  public editMapShareWithOthersReply(id: number, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}community/map-share-with-others/edit-reply/${id}`, payload);
  }

  public deleteMapShareWithOthersReply(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}community/map-share-with-others/delete-reply/${id}`);
  }

  public getMapShareWithOthersUsersAndAnswers(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/map-share-with-others/get-users-and-answers`, {
      params: payload
    });
  }

  public getMapCustomLineChart(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/map-custom-line-chart/get`, {
      params: payload
    });
  }

  public addMapCustomLineChart(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/map-custom-line-chart/add`, payload);
  }

  public deleteMapCustomLineChart(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}community/map-custom-line-chart/delete/${id}`);
  }

  public getPopUpImages(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/pop-up-images/get`, {
      params: payload
    });
  }

  public addPopUpImage(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/pop-up-images/add`, payload);
  }
  public deletePopUpImage(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}community/pop-up-images/delete/${id}`);
  }

  public getMapCustomization(payload: any): Observable<any> {
    return this.http.get(`${this.baseUrl}community/map-customization/get`, {
      params: payload
    });
  }

  public addMapCustomization(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}community/map-customization/add`, payload);
  }
}
